import React from 'react'
import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const gradingMethodService = {

    addGradingMethod,
    getGradingMethods,
    deleteGradingMethod,
    updateGradingMethod
};

async function addGradingMethod(obj) {
    const requestOptions = {
      method: "POST",
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      body: JSON.stringify(obj),
    };
    const response = await fetch(
      `${config.oat_api_url}/manage/grading-methods/add/`,
      requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getGradingMethods() {
    const requestOptions = {
      method: "GET",
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
      `${config.oat_api_url}/manage/grading-methods/getAll/`,
      requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteGradingMethod(id){

    const configOptions = {
        method: "DELETE",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        };

        const response = await fetch(
        `${config.oat_api_url}/manage/grading-methods/delete/${id}`,
        configOptions
        );
        return APIHandler.handleResponse(response);

}
async function updateGradingMethod(id, payload) {
    const requestOptions = {
      method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(payload),
    };
    const response = await fetch(
      `${config.oat_api_url}/manage/grading-methods/update/${id}`,
      requestOptions
    );
    return APIHandler.handleResponse(response);
}


